<script>
import StaticLink from 'tripod-styles/src/components/Buttons/StaticLink.svelte';
import MediaQuery from './../../../components/MediaQuery.svelte';
import RecommendedTag from './RecommendedTag.svelte';
import DiscountText from './DiscountText.svelte';
import CurrencyFormatter from "../../../components/Elements/CurrencyFormatter.svelte";
import { ApplicationData } from 'tripod-styles/src/libraries/ApplicationData';
import { parse_membership_name } from 'tripod-styles/src/models/SubscriptionInterface';


export let has_products;
export let metadata;
export let interval;
export let SelectPlanInit;
export let select_plan_lang;
export let lang;
export let plan;

let avoid_disabled_current = tripod_plans?.avoid_disabled_current ?? false;
let show_free_trial_tags = tripod_plans?.show_free_trial_tags ?? true;
let free_trial_tag = metadata?.lang?.free_trial_tag ?? "14-day free trial";
let skip_trial = metadata?.lang?.skip_trial ?? "Skip free trial";

let free_trial_plan = false;
if(plan.id_plan === "pl_H_mlok" && show_free_trial_tags){
    free_trial_plan = true;
}

if(free_trial_plan){
    select_plan_lang = window.get_contents_all("ctn_nWUJUP") ?? "Seleccionar prueba";
}
let coming_soon = window.get_contents_all("ctn_DoYzrn") ?? "Coming soon!";
let first_month_after = "";

let user = window?.user ?? null;
let subscription_suite = ApplicationData.get_subscription("suite", user) ?? null;

function is_coming_soon(){
    return false;
    return !plan.id_plan.search("pl_LdtycZ|pl_Te8nj-");
}

function is_unlimited_beta(plan){
    return false;
    return plan.id_plan === "pl_-He4DX" && interval === "month";
}

let price_beta = 1;
/*
if(is_unlimited_beta(plan)){
    first_month_after = "";
    

    first_month_after = "<br>"+(window.get_contents_all("ctn_tudgxR") ?? "1er mes, después: ") + `${first_month_after} $${plan.interval_price}`;

    if(subscription_suite !== null){
        first_month_after = `${metadata.lang.eachMonth}`;
        price_beta = plan.interval_price;
    }
}else{
    first_month_after = "";
}
*/
function set_offer_type_according_to_price(plan){
    return (plan.membership_type === "suite" && plan.price_plan < 30) ? "essential-or-low" : "any";
}

</script>
<card-plan class="column column-card-plan card-plan-header is-relative container-plan-{plan.__id__}">
    <MediaQuery query="(min-width:769px)">
        <RecommendedTag 
            has_products={has_products}
            plan={plan}
            metadata={metadata}
        />
    </MediaQuery>
    <section class="{plan.is_recommended} {has_products ? 'has-products pt-0' : ""} subcontainer section-card is-plan padding-40 has-radius">
        <MediaQuery query="(max-width:768px)">
            <RecommendedTag 
                has_products={has_products}
                plan={plan}
                metadata={metadata}
            />
        </MediaQuery>
        <header class="header-default-plan after-promo">
            <div class="is-grid is-gap-10 item-header">
                <div class="is-gap-10 main-content-header">
                    {#if show_free_trial_tags === true && plan.id_plan === "pl_H_mlok"}
                        <p class="free-trial-tag">
                            <span class="tag is-primary font-restricted-size-12 fw500">
                                {free_trial_tag}
                            </span>
                        </p>
                    {/if}
                    <h2 class="font-size-24 pb-alt-2 font-restricted-size-18-touch title-plan has-text-weight-bold has-text-black Title-Plan-{plan.is_recommended}">
                        <span class="name_plan-span">
                            {plan.name_plan}
                        </span>
                        <DiscountText class="is-hidden-desktop is-hidden-tablet" plan={plan} />
                    </h2>
                    {#if is_coming_soon()}
                        <h2>
                            {@html coming_soon}
                        </h2>
                        <p>
                            <br>
                            <br>
                        </p>
                    {/if}                     
                    {#if !is_coming_soon()}
                        <p class="font-size-24 content-prices has-text-weight-semibold price-element-container main-price {plan.is_recommended}">
                            <span class="price-element has-text-black">
                                <span class="font-size-24 fw500">
                                    {plan.currency[0]}
                                    <CurrencyFormatter 
                                        interval={interval} 
                                        parseCents={true} 
                                        number={is_unlimited_beta(plan) ? price_beta : plan.interval_price} 
                                    />
                                    <span class="font-size-20 fw500">
                                        {plan.currency[1]}
                                        {#if plan.type === "PLAN"}
                                            <span>
                                                /{@html (is_unlimited_beta(plan) ? first_month_after : metadata.lang.eachMonth)}
                                            </span>
                                        {/if}
                                    </span>
                                </span>
                            </span>
                        </p>
                        {#if (plan?.hasReferralDiscounts ?? false) !== false}
                            <p class="has-text-centered font-size-24 has-text-weight-semibold price-element-container dontpay-price">
                                <span class="price-element has-text-black">
                                    <span class="font-size-14 fw500" style="text-decoration: line-through;">
                                        {plan.currency[0]}
                                        <CurrencyFormatter interval={interval} classes="font-size-14" parseCents={true} number={plan.interval_current_price} />
                                        {plan.currency[1]}
                                        {#if plan.type === "PLAN"}
                                            <span>
                                                /{metadata.lang.eachMonth}
                                            </span>
                                        {/if}
                                    </span>
                                </span>
                            </p>
                        {/if}
                        {#if plan.yearly !== null && interval === "year"}
                            {#if plan[`interval_${interval}_price`] ?? "" !== ""}
                                <p class="content-on-year font-size-14 has-text-black">
                                    {#if interval === "year"}
                                        {plan.currency[0]}<CurrencyFormatter interval={interval} classes="font-restricted-size-14" parseCents={true} number={plan.interval_price*12} />
                                    {/if}
                                    {plan.currency[1]}/<span class="is-lowercase">{metadata.lang.year}</span>
                                </p>
                            {/if}
                        {/if}
                        <DiscountText class="is-hidden-mobile" plan={plan} />
                    {/if}
                </div>
                <!-- pay button start -->
                <section class="button-pay">
                    {#if plan.active === false || avoid_disabled_current === true }
                        <div class="buttons is-grouped is-centered button-container-select">
                            <button
                                on:click="{SelectPlanInit}"
                                data-plan-id="{plan.__id__}" 
                                data-add_trial_end={free_trial_plan === true ? "yes" : "no"}
                                data-price-on-year-monthly="{plan.price_on_year_monthly}"
                                data-position-plan="{plan.position_plan}"
                                data-type="{plan.type}"
                                data-membership-type="{parse_membership_name(plan.membership_type)}"
                                data-offer-type="{set_offer_type_according_to_price(plan)}"
                                data-interval="{interval}"
                                type="button" class="button is-primary button-select-plan">
                                <span class="is-capitalized">
                                    {select_plan_lang}
                                </span>
                            </button>
                            {#if free_trial_plan}
                                <button
                                    on:click="{SelectPlanInit}"
                                    data-plan-id="{plan.__id__}"
                                    data-price-on-year-monthly="{plan.price_on_year_monthly}"
                                    data-position-plan="{plan.position_plan}"
                                    data-type="{plan.type}"
                                    data-membership-type="{parse_membership_name(plan.membership_type)}"
                                    data-interval="{interval}"
                                    type="button" class="button is-ghost is-paddingless is-marginless button-select-plan">
                                    <span class="is-capitalized has-text-primary">
                                        {skip_trial}
                                    </span>
                                </button>
                            {/if}
                        </div>
                        {:else}
                            <!-- current plan -->
                            <div class="buttons is-grouped is-centered button-container-select">
                                <button 
                                    data-plan-id="{plan.__id__}"
                                    data-type="{plan.type}"
                                    data-membership-type="{plan.membership_type}"
                                    data-interval="{interval}"
                                    type="button" 
                                    class="button is-primary button-select-plan is outlined-white fw400 has-text-white button-primary-3pod outlined-white"
                                    disabled="true"                                        
                                >
                                    <span class="is-capitalized">
                                        {lang.currentPlan ?? lang.updatePlan ?? select_plan_lang}
                                    </span>
                                </button>
                            </div>
                    {/if}
                </section>               
            </div>                    
        </header>
    </section>
</card-plan>
<main class="benefits-content">
    <slot></slot>
</main>
<style>
.free-trial-tag{
    position: absolute;
    top: -29px;
    right: 12px;
}
@media only screen and (max-width:900px){
    .section-card{
        background-color: #fff;
    }
}
</style>